/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {WidgetTypeEnum} from './WidgetTypeEnum';
import {
  WidgetTypeEnumFromJSON,
  WidgetTypeEnumFromJSONTyped,
  WidgetTypeEnumToJSON
} from './WidgetTypeEnum';

/**
 *
 * @export
 * @interface CalculationResultWidget
 */
export interface CalculationResultWidget {
  /**
   *
   * @type {string}
   * @memberof CalculationResultWidget
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof CalculationResultWidget
   */
  name: string;
  /**
   *
   * @type {WidgetTypeEnum}
   * @memberof CalculationResultWidget
   */
  widgetType: WidgetTypeEnum;
  /**
   *
   * @type {any}
   * @memberof CalculationResultWidget
   */
  data: any | null;
}

/**
 * Check if a given object implements the CalculationResultWidget interface.
 */
export function instanceOfCalculationResultWidget(value: object): value is CalculationResultWidget {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('widgetType' in value) || value['widgetType'] === undefined) return false;
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function CalculationResultWidgetFromJSON(json: any): CalculationResultWidget {
  return CalculationResultWidgetFromJSONTyped(json, false);
}

export function CalculationResultWidgetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculationResultWidget {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    widgetType: WidgetTypeEnumFromJSON(json['widget_type']),
    data: json['data']
  };
}

export function CalculationResultWidgetToJSON(value?: CalculationResultWidget | null): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    widget_type: WidgetTypeEnumToJSON(value['widgetType']),
    data: value['data']
  };
}
